// extracted by mini-css-extract-plugin
module.exports = {"overlay":"HolidaySnow_overlay__RB342","flake":"HolidaySnow_flake___E3z1","holiday-snow-fall":"HolidaySnow_holiday-snow-fall__qNY63"};